import React, {useEffect, useState} from 'react';
import {Route, Routes, Navigate} from 'react-router-dom';
import {useSelector, useDispatch} from 'react-redux';
import {checkToken} from './utils/auth';
import {routesConfig} from './routes/routesConfig';
import ProtectedRoute from './routes/ProtectedRoute';
import Home from './pages/Home';
import SuperAdminPanel from './pages/SuperAdminPanel';
import UserPanel from './pages/UserPanel';
import {checkPayment} from './utils/payment';
import Packages from './components/forms/admin/packages';
import CustomModal from './components/customModal/customModal';
import useModal from './hooks/useModal';
import { fetchAllCurrencies } from './features/currency/currencyActions';
import { io } from "socket.io-client";


const App = () => {
  const dispatch = useDispatch();
  const {isLoggedIn, role} = useSelector((state) => state.app);
  const {isOpen, toggleModal} = useModal()

  useEffect(() => {
    checkToken(dispatch);
    const paymentStatus = localStorage.getItem('paymentStatus');
    const isPaid = checkPayment(dispatch, paymentStatus);
    if (!isPaid && isLoggedIn) {
      toggleModal();
    }
  }, [dispatch, isLoggedIn]);
  useEffect(()=>{
  fetchAllCurrencies(dispatch)
},[dispatch])

  return (
    <>
      {/* <CustomModal
        isOpen={isOpen}
        onClose={toggleModal}
        modalTitle="Update Package"
      >
        <Packages onClose={toggleModal}/>
      </CustomModal> */}
      <Routes>
        {routesConfig.map(({path, element, protected: isProtected}) => {
          const routeElement = isProtected ? (
            <ProtectedRoute>
              {role === process.env.REACT_APP_SUPERADMIN_ROLE_ID ? (
                <SuperAdminPanel>{element}</SuperAdminPanel>
              ) : role === process.env.REACT_APP_USER_ROLE_ID ? (
                <UserPanel>{element}</UserPanel>
              ) : (
                <Home>{element}</Home>
              )}
            </ProtectedRoute>
          ) : (
            element
          );

          if (path === '/' && isLoggedIn) {
            if (role === process.env.REACT_APP_ADMIN_ROLE_ID) {
              return (
                <Route
                  key={path}
                  path={path}
                  element={<Navigate to="/dashboard" />}
                />
              );
            } else if (role === process.env.REACT_APP_USER_ROLE_ID) {
              return (
                <Route
                  key={path}
                  path={path}
                  element={<Navigate to="/user/dashboard" />}
                />
              );
            } else if (role === process.env.REACT_APP_SUPERADMIN_ROLE_ID) {
              return (
                <Route
                  key={path}
                  path={path}
                  element={<Navigate to="/admin/dashboard" />}
                />
              );
            }
          }

          return <Route key={path} path={path} element={routeElement} />;
        })}
      </Routes>
    </>
  );
};

export default App;
